"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Analytics = /*#__PURE__*/function () {
  function Analytics(client) {
    (0, _classCallCheck2["default"])(this, Analytics);
    this.client = client;
    this.resourceUrl = '/analytics';
  }

  (0, _createClass2["default"])(Analytics, [{
    key: "getMostFavModule",
    value: function getMostFavModule() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/most-favorited"), args);
    }
  }, {
    key: "getPostSession",
    value: function getPostSession() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/open-post-session"), args);
    }
  }, {
    key: "getListenPSPAudio",
    value: function getListenPSPAudio() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/listen-post-session-audio"), args);
    }
  }, {
    key: "getAbandonSurvey",
    value: function getAbandonSurvey() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/complete-abandon-survey"), args);
    }
  }, {
    key: "getIntentionAndInsightLog",
    value: function getIntentionAndInsightLog() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/intention-insight-logged"), args);
    } // getCtrSRQ(...args) {
    //   return this.client.get(`${this.resourceUrl}/ctr-srq`, args)
    // }

  }, {
    key: "getListenSRQAudio",
    value: function getListenSRQAudio() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.client.get("".concat(this.resourceUrl, "/listen-srs-audio"), args);
    }
  }, {
    key: "getBreakthroughJournal",
    value: function getBreakthroughJournal() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this.client.get("".concat(this.resourceUrl, "/breakthrough-journal"), args);
    }
  }, {
    key: "getMediaLibraryData",
    value: function getMediaLibraryData() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      return this.client.get("".concat(this.resourceUrl, "/listen-audio-media-library"), args);
    }
  }, {
    key: "getLandingPageData",
    value: function getLandingPageData() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return this.client.get("".concat(this.resourceUrl, "/landing-page"), args);
    }
  }]);
  return Analytics;
}();

exports["default"] = Analytics;